import { horizontalScroll } from '../../js/front/components/horizontal-scroll';


document.querySelectorAll( '.b-features-tabs' ).forEach( ( block ) => {

	const mediaQuery = window.matchMedia( '(max-width: 896px)' );
	const titles = block.querySelectorAll( '.b-features-tabs__titles .b-cell' )
	const cards = block.querySelectorAll( '.b-features-tabs__cards .b-features-tabs-card' )

	/**
	 * Sets the 'data-index' attribute on each element in the provided array based on their index.
	 *
	 * @param {Array} elements - The array of elements to set the 'data-index' attribute for.
	 */
	const setIndex = ( elements ) => {

		if ( elements ) {

			elements.forEach( ( element, index ) => {

				element.setAttribute( 'data-index', index );

			} );

		}

	}

	/**
	 * Sets initial active class and height for the first title and card in the given elements.
	 * If the "titles" array is not empty, it adds the class "is-active" to the first title element.
	 * If the "cards" array is not empty, it adds the class "is-active" to the first card element.
	 * Additionally, it sets the CSS variable "--card-content-height" to the computed height of the first card content element.
	 * @function
	 */
	const setInitialActiveClassAndHeight = () => {

		if ( titles ) {

			titles[ 0 ].classList.add( 'is-active' );

		}
		if ( cards ) {

			cards[ 0 ].classList.add( 'is-active' );

			const cardContent = cards[ 0 ].querySelector( '.b-features-tabs-card-content' );
			cards[ 0 ].style.setProperty( '--card-content-height', `${cardContent.scrollHeight}px` );

			// Observe card content height changes
			new ResizeObserver( () => {

				cards[ 0 ].style.setProperty( '--card-content-height', `${cardContent.scrollHeight}px` );

			} ).observe( cardContent );

		}

	}


	/**
	 * Scrolls titles on mobile if the given media query list matches.
	 * If the media query list matches, it calls the `horizontalScroll` function on the titles element.
	 * If the media query list does not match, it logs a message to the console.
	 *
	 * @param {object} e - The media query list to check for matching.
	 */
	const scrollTitlesOnMobile = ( e ) => {

		if ( e.matches ) {

			horizontalScroll( '.b-features-tabs__titles' )

		}

	}

	setIndex( titles )
	setIndex( cards )
	setInitialActiveClassAndHeight()

	mediaQuery.addEventListener( 'change', scrollTitlesOnMobile );
	scrollTitlesOnMobile( mediaQuery )


	titles.forEach( ( title, index ) => {

		title.addEventListener( 'click', () => {

			titles.forEach( activeTitle => activeTitle.classList.remove( 'is-active' ) );
			cards.forEach( card => card.classList.remove( 'is-active' ) );

			title.classList.add( 'is-active' );

			if ( cards[ index ] ) {

				cards[ index ].classList.add( 'is-active' );
				const cardContent = cards[ index ].querySelector( '.b-features-tabs-card-content' )
				cards[ index ].style.setProperty( '--card-content-height', `${cardContent.scrollHeight}px` )

				new ResizeObserver( () => {

					cards[ index ].style.setProperty( '--card-content-height', `${cardContent.scrollHeight}px` );

				} ).observe( cardContent );

			}

		} );

	} );


} );
